import { render, staticRenderFns } from "./homeDeptRole.vue?vue&type=template&id=f9ced7de&scoped=true&"
import script from "./homeDeptRole.vue?vue&type=script&lang=js&"
export * from "./homeDeptRole.vue?vue&type=script&lang=js&"
import style0 from "./homeDeptRole.vue?vue&type=style&index=0&id=f9ced7de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ced7de",
  null
  
)

export default component.exports